/* Klikmeting actiebanners (actie-duo, tegel in het raster, label op de productpagina, winkelwagen).
   Hoort bij docs/actiebanners.md. Event actiebanner_klik met plek en actie, naar GA4 (dataLayer en gtag)
   en Amplitude (window.vcAmplitude). */
(function () {
  'use strict';
  if (window.__vcActieMeting) return;
  window.__vcActieMeting = true;
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-actie-klik]') : null;
    if (!a) return;
    var props = { plek: a.getAttribute('data-actie-klik') || 'onbekend', actie: a.getAttribute('data-actie') || 'onbekend' };
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'actiebanner_klik', banner_plek: props.plek, actie: props.actie }); } catch (err) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'actiebanner_klik', { banner_plek: props.plek, actie: props.actie }); } catch (err) {}
    try { if (window.vcAmplitude && typeof window.vcAmplitude.track === 'function') window.vcAmplitude.track('actiebanner_klik', props); } catch (err) {}
  });
})();
